$(document).ready(function() {
    /**
     * Enable popovers everywhere
     */
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl)
    });

    /**
     * Enable tooltips everywhere
     */
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    });

});

/**
 * MASCARAS DE CAMPOS
 */

function mascaraMutuario(o,f){
    v_obj=o
    v_fun=f
    setTimeout('execmascara()',1)
}

function execmascara(){
    v_obj.value=v_fun(v_obj.value)
}

function cpfCnpj(v){

    //Remove tudo o que não é dígito
    v=v.replace(/\D/g,"")

    if (v.length <= 11) { //CPF

        //Coloca um ponto entre o terceiro e o quarto dígitos
        v=v.replace(/(\d{3})(\d)/,"$1.$2")

        //Coloca um ponto entre o terceiro e o quarto dígitos
        //de novo (para o segundo bloco de números)
        v=v.replace(/(\d{3})(\d)/,"$1.$2")

        //Coloca um hífen entre o terceiro e o quarto dígitos
        v=v.replace(/(\d{3})(\d{1,2})$/,"$1-$2")

    } else { //CNPJ

        //Coloca ponto entre o segundo e o terceiro dígitos
        v=v.replace(/^(\d{2})(\d)/,"$1.$2")

        //Coloca ponto entre o quinto e o sexto dígitos
        v=v.replace(/^(\d{2})\.(\d{3})(\d)/,"$1.$2.$3")

        //Coloca uma barra entre o oitavo e o nono dígitos
        v=v.replace(/\.(\d{3})(\d)/,".$1/$2")

        //Coloca um hífen depois do bloco de quatro dígitos
        v=v.replace(/(\d{4})(\d)/,"$1-$2")

    }
    return v
}

$('.cpf_cnpj').keyup(function(){
    mascaraMutuario(this,cpfCnpj);
}).blur(function(){
    var val = $(this).val();
    val = val.replace(/\D/g,"");

    if(val.length < 11){
        $(this).val('');
    }else if(val.length < 14 && val.length > 11){
        $(this).val('');
    }
    clearTimeout();
});

$(document).on("focus", ".maskHora", function () {
    $('.maskHora').mask('99:99', {reverse: true});
});
$(document).on("focus", ".maskDataHora", function () {
    $('.maskDataHora').mask('99/99/9999 99:99', {reverse: true});
});
$(document).on("focus", ".maskData", function () {
    $('.maskData').mask('99/99/9999', {reverse: true});
});
$(document).on("focus", ".maskCEP", function () {
    $('.maskCEP').mask('99999-999', {reverse: true});
});
$(document).on("focus", ".maskValor", function () {
    var mask = '999.999,99';
    var maxlength = $(this).attr('maxlength');
    if (maxlength!='') {
        mask = mask.substr(maxlength * -1);
    }
    $('.maskValor').mask(mask, {reverse: true});
});
$(document).on("focus", ".maskCPF", function () {
    $('.maskCPF').mask('999.999.999-99', {reverse: true});
});
$(document).on("focus", ".maskCNPJ", function () {
    $('.maskCNPJ').mask('99.999.999/9999-99', {reverse: true});
});
$(document).on("focus", ".maskTelefone", function () {
    /*var TelefoneMaskBehavior = function (val) {
            return val.replace(/\D/g, '').length === 11 ? '(99) 9999-9999' : '(99) 9999-99999';
        },
        spOptions = {
            onKeyPress: function(val, e, field, options) {
                field.mask(TelefoneMaskBehavior.apply({}, arguments), options);
            }
        };
    $('.maskTelefone').mask(TelefoneMaskBehavior, spOptions);*/
    $(".maskTelefone")
        .mask("(99) 9999-9999?9")
        .focusout(function (event) {
            var target, phone, element;
            target = (event.currentTarget) ? event.currentTarget : event.srcElement;
            phone = target.value.replace(/\D/g, '');
            element = $(target);
            element.unmask();
            if(phone.length > 10) {
                element.mask("(99) 99999-999?9");
            } else {
                element.mask("(99) 9999-9999?9");
            }
        });
});

$(function() {
    $('.maskMoney').maskMoney({
        thousands: '',
        prefix: 'R$ ',
        affixesStay: false
    });
})

/*$(function() {
    $('.datepicker').datepicker({
        language: "pt-BR"
    });
});*/

/** DATE TIME PICKER CALENDARIO **/
function inputDataHora() {
    $('.inputDataHora').datetimepicker({
        showClear: false,
        showTodayButton: false,
        locale: 'pt-br',
        tooltips: {
            today: 'Hoje',
            clear: 'Limpar data'
        }
    });
}

$(function() {
    inputDataHora();
});

function somenteNumeros(e) {
    var charCode = e.charCode ? e.charCode : e.keyCode;
    // charCode 8 = backspace
    // charCode 9 = tab
    if (charCode != 8 && charCode != 9) {
        // charCode 48 equivale a 0
        // charCode 57 equivale a 9
        if (charCode < 48 || charCode > 57) {
            return false;
        }
    }
}

/**
 * AJAX ESTADOS / CIDADES 
 */
$(document).on('change','.form-select-pais',function(){
    var pais = $(this).val();
    var target = $(this).attr('data-target');
    var targetCity = $(this).attr('data-city');

    $(target).html('<option value="">Carregando cidades...</option>');
    $(targetCity).html('<option value="">Selecione</option>'); 
    $.ajax({
        type: "POST",
        data: {pais: pais},
        url: "select-estados",
        success: function (result) {
            $(target).html(result);
        }
    });
});

$(document).on('change','.form-select-estado',function(){
    var uf = $(this).val();
    var returnCode = $(this).attr('data-return-code');
    var target = $(this).attr('data-target');
    $(target).html('<option value="">Carregando cidades...</option>');
    $.ajax({
        type: "POST",
        data: {uf: uf, returnCode: returnCode},
        url: "select-cidades",
        success: function (result) {
            $(target).html(result);
        }
    });
});

/**
 * PREVIEW IMAGEM UPLOAD
 */
function readURL(input) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = function(e) {
            $('#preview-imagem').attr('src', e.target.result);
        }
        reader.readAsDataURL(input.files[0]);
    }
}

$(document).on('change', '#imagem', function() {
    readURL(this);
});

/**
 * CONTROLA O TAMANHO DA IMAGEM
 */
function bytesToSize(bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}

$(document).on('click', '.btn-check-file-size', function() {
    var size = $(this).attr('data-size');
    var field = $(this).attr('data-target');
    var fileLenght = $(field)[0].files.length;

    if(fileLenght === 0) {
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            confirmButtonColor: '#2fb344',
            text: 'Você não selecionou uma imagem!'
        });
    } else {
        //check whether browser fully supports all File API
        if (window.File && window.FileReader && window.FileList && window.Blob) {
            //get the file size and file type from file input field
            var fsize = $(field)[0].files[0].size;
            //do something if file size more than 500kb
            if (fsize > size) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    confirmButtonColor: '#2fb344',
                    text: 'A imagem é maior do que o permitido ('+bytesToSize(size)+')!'
                });
            } else {
                $(field).closest('form').submit();
            }
        } else {
            Swal.fire({
                icon: 'info',
                title: 'Atenção',
                confirmButtonColor: '#2fb344',
                text: 'Atualize seu navegador, porque seu navegador atual não possui alguns recursos novos de que precisamos!'
            });
        }
    }
});

if ($('.select-filiais').length) {
    var select2Filiais = $(".select-filiais").select2({
        placeholder: 'Selecione'
    });
}

$(document).on('change','.select-tipo-user',function(){
    var valor = $(this).val();
    valor = valor.split('|');
    if(parseInt(valor[0]) === 6){
        $(".aprovaFotos input").attr('required','required');
        $(".aprovaFotos").show();
    }else{
        $(".aprovaFotos input").prop('checked', false).removeAttr('required');
        $(".aprovaFotos").hide();
    }
    if(parseInt(valor[0]) !== 1 && parseInt(valor[0]) !== 6 && parseInt(valor[0]) < 8){
        $(".formFiliais").show();
        select2Filiais.val(null).trigger("change")
        $(".formFiliais select").attr('required','required');
    }else{
        select2Filiais.val(null).trigger("change")
        $(".formFiliais select").removeAttr('required');
        $(".formFiliais").hide();
    }
    /*select2Filiais.val(null).trigger("change");
    $(".select-filiais").removeAttr('multiple');
    select2Filiais.select2();*/
});

/**
 * SELECT 2 PRODUTOS
 */
$(".js-select2-produtos").select2({
    ajax: {
        //url: 'select2-produtos?id=nome',
        dataType: 'json'
    },
    minimumInputLength: 3,
    placeholder: "Selecione",
    "language":{
        errorLoading: function () {
            return 'Os resultados não puderam ser carregados.';
        },
        searching: function () { return 'Buscando…'; },
        "noResults" : function () { return 'Nenhum item encontrado'; },
        inputTooShort: function (args) {
            var remainingChars = args.minimum - args.input.length;
            var message = 'Digite ' + remainingChars + ' ou mais caracteres';
            return message;
        },
    }
});

function getURL() {
    var marca = $(".js-select2-produtos-mostras").attr('data-marca');

    if(marca !== '' && marca !== undefined && marca !== null) {
        return 'select2-produtos?id=codigo&marca=' + $(".js-select2-produtos-mostras").attr('data-marca');
    }else{
        return false;
    }
}
var select2ProdutosMostras = $(".js-select2-produtos-mostras").select2({
    ajax: {
        url:  function() {
            return getURL();
        },
        dataType: 'json'
    },
    minimumInputLength: 3,
    placeholder: "Selecione",
    "language":{
        errorLoading: function () {
            return 'Os resultados não puderam ser carregados.';
        },
        searching: function () { return 'Buscando…'; },
        "noResults" : function () { return 'Nenhum item encontrado'; },
        inputTooShort: function (args) {
            var remainingChars = args.minimum - args.input.length;
            var message = 'Digite ' + remainingChars + ' ou mais caracteres';
            return message;
        },
    }
});

$(document).on('change','#marcaSelect',function(){
    var marca = $(this).val();
    var numProds = $('#produtosContainer tr').length;
    var numProdsMarca = $('#produtosContainer tr[data-marca="' + marca + '"]').length;
    if(numProds < 1 || numProdsMarca > 0){
        if(marca !== '' && marca !== undefined && marca !== null){
            $('#produtoSelect').attr('data-marca',marca);
            select2ProdutosMostras.val("").trigger("change");
        }else{
            $('#produtoSelect').attr('data-marca','');
        }
    }else{
        $('#marcaSelect').val($(".js-select2-produtos-mostras").attr('data-marca'));
        Swal.fire({
            icon: 'warning',
            title: 'Só é permitido uma marca por projeto!',
            confirmButtonColor: '#2fb344',
            html: 'Caso queira alterar a marca, <br>é necessário excluir os produtos da outra marca'
        });
    }
});

$(document).on('click', '#btnAddProduto', function(e) {
    e.preventDefault();
    var produto = $('#produtoSelect').val();
    var m2pcs = $('#m2Pcs').val();
    var total_m2pcs = $('#total_m2Pcs').val();
    var marca = $(".js-select2-produtos-mostras").attr('data-marca');
    if($('#' + produto).length > 0) {
        Swal.fire({
            icon: 'warning',
            title: 'Oops...',
            confirmButtonColor: '#2fb344',
            html: 'Este produto já foi adicionado.<br>Caso queira você pode alterar as quantidades.'
        });
    }else{
        Swal.fire({
            html: 'Favor certifique-se, antes de finalizar a solicitação, de que o produto escolhido tenha estoque disponível.',
            icon: 'warning',
            confirmButtonColor: '#2fb344',
            confirmButtonText: 'Ok, entendi'
        }).then(function(res) {
            $.ajax({
                type: "POST",
                url: 'add-produtos',
                context: this,
                data: { produto : produto, m2pcs : m2pcs, total_m2pcs : total_m2pcs, marca : marca},
                success: function (result) {
                    $('#produtosContainer').append(result);
                    select2ProdutosMostras.val("").trigger("change");
                    $('#m2Pcs').val('');
                    $('#total_m2Pcs').val('');
                }
            });
        });
    }
});

$(document).on('click', '.btnExcluiProduto', function(e) {
    $(this).parent().parent().remove();
});



/**
 * MODAIS
 */
$(document).on('click', '.btn-modal', function(e) {
    e.preventDefault();
    var modal = $(this).attr('href');
    var codigo = $(this).attr('data-codigo');
    $.post('modal-'+modal, { codigo: codigo },
        function(resultado) {
            $('body').append(resultado);
            $('#'+modal).modal('show');

            if ($("#formEntrevistaCadastrar").length) {
                formEntrevistaCadastrar();
            }
            if ($("#formInserirValor").length) {
                formInserirValor();
            }
            if ($("#formLiberaProduto").length) {
                formLiberaProduto();
            }
            if ($("#formAlbumCadastrar").length) {
                formAlbumCadastrar();
            }

            $('#'+modal).on('hidden.bs.modal', function (e) {
                $('#'+modal).remove();
            });
        }
    );
});

//Abre a modal para cadastrar a entrevista direto pela url na pagina onde lista as mostras
if($("#mEntrevista").length){
    var codigo = $('#mEntrevista').attr('data-id');
    $.post('modal-cadastro-entrevista', { codigo: codigo },
        function(resultado) {
            $('body').append(resultado);
            $('#cadastro-entrevista').modal('show');

            formEntrevistaCadastrar();

            $('#cadastro-entrevista').on('hidden.bs.modal', function (e) {
                $('#cadastro-entrevista').remove();
            });
        }
    );
}

/**
 * LINK SCROLL
 */
function goToSection__scroll(elScrollDestiny, distanceIfScrollGoingToUp, distanceIfScrollGoingToDown, speedScroll) {
    console.clear();
    // scroll reference
    var scrollEfetuado = $(window).scrollTop();
    console.log(scrollEfetuado);
    // element reference
    var sectionDestiny_offsetTop = $(elScrollDestiny).offset().top;
    console.log(elScrollDestiny);
    console.log(sectionDestiny_offsetTop);

    if (scrollEfetuado > sectionDestiny_offsetTop) {
        console.log('vai subir');
        $('html, body').animate({
            scrollTop: sectionDestiny_offsetTop - distanceIfScrollGoingToUp
        }, speedScroll);
    } else {
        console.log('vai descer');
        $('html, body').animate({
            scrollTop: sectionDestiny_offsetTop - distanceIfScrollGoingToDown
        }, speedScroll);
    }
}

$('.js-linkScroll').on('click', function(e) {
    e.preventDefault();
    var finalDestiny = $(this).attr('href');
    goToSection__scroll(finalDestiny, 125, 125, 700);
});

/**
 * ATIVO INATIVO NAS LISTAS DE REGISTROS
 * Uso:
 * <label class="form-check form-switch mb-0 d-inline-block">
 *     <input class="form-check-input form-ativo" name="ativo" value="S" data-tipo="segmento" data-codigo="<?php echo md5($row['codigo']); ?>" type="checkbox" <?php echo ($row['ativo']=='S') ? 'checked' : ''; ?> >
 * </label>
 */
$('.form-ativo').change(function() {
    var tipo = $(this).attr('data-tipo')+"-situacao";
    var codigo = $(this).attr('data-codigo');
    var novo_valor = '';
    if(this.checked) {
        novo_valor = 'S';
        $(this).prop("checked", true);
    } else {
        $(this).prop("checked", false);
        novo_valor = '';
    }

    $.ajax({
        type: "POST",
        url: tipo,
        context: this,
        data: { codigo : codigo, valor : novo_valor, acao : tipo},
        success: function (result) {
            $('.row-images-cards').html(result);
        }
    });
});

$("#formMarca").validate({
    submitHandler: function (form) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                $('#formMarca .btnSave').html('<span class="spinner-border spinner-border-sm mr-2" role="status"> </span> Salvando ...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                console.log(result);
                if(parseInt(result[0]) === 1){
                    Swal.fire({
                        title: result[1],
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        location.href = 'marcas/listar';
                    });
                }else{
                    Swal.fire({
                        text: result[1],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        $('#formMarca .btnSave').html('Salvar').attr('disabled', false);
                    });
                }
            }
        });
    }
});

$(document).on('click', '.btnExcluirMarca', function(e) {
    e.preventDefault();
    var codigo = $(this).attr('data-codigo');
    Swal.fire({
        title: 'Deseja remover realmente?',
        text: "Esta ação irá remover todas as informações relacionadas esta marca!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonText: 'Sim, excluir!'
    }).then((result) => {
        if (result.value) {
            $.ajax({
                type: "POST",
                data: {codigo: codigo, acao: 'marca-remover'},
                url: "marca-remover",
                success: function (result) {
                    result = result.split('|');
                    if (parseInt(result[0]) === 1) {
                        Swal.fire({
                            title: result[1],
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(function(res) {
                            location.href = 'marcas/listar';
                        });
                    } else {
                        Swal.fire({
                            text: result[1],
                            icon: 'error',
                            timer: 5000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    }
                }
            });
        }
    });
});

$("#formMostra").validate({
    submitHandler: function (form) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                $('#formMostra .btnSave').html('<span class="spinner-border spinner-border-sm mr-2" role="status"> </span> Salvando ...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                console.log(result);
                if(parseInt(result[0]) === 1){
                    Swal.fire({
                        title: result[1],
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        location.href = 'mostras';
                    });
                }else{
                    Swal.fire({
                        text: result[1],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        $('#formMostra .btnSave').html('Salvar').attr('disabled', false);
                    });
                }
            }
        });
    }
});

$(document).on('click', '.btnExcluirMostra', function(e) {
    e.preventDefault();
    var codigo = $(this).attr('data-codigo');
    var planta = $(this).attr('data-planta');
    Swal.fire({
        title: 'Deseja remover realmente?',
        text: "Esta ação irá remover todas as informações relacionadas desta solicitação!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonColor: '#2fb344',
        confirmButtonText: 'Sim, excluir!'
    }).then((result) => {
        if (result.value) {
            $.ajax({
                type: "POST",
                data: {codigo: codigo, planta: planta, acao: 'mostra-remover'},
                url: "mostra-remover",
                success: function (result) {
                    result = result.split('|');
                    if (parseInt(result[0]) === 1) {
                        $('#mostra' + codigo).remove();
                        Swal.fire({
                            title: result[1],
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    } else {
                        Swal.fire({
                            text: result[1],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    }
                }
            });
        }
    });
});

$(document).on('click', '.btnEncerrarMostra', function(e) {
    e.preventDefault();
    var codigo = $(this).attr('data-codigo');
    var processo = $(this).attr('data-processo');
    Swal.fire({
        title: 'Deseja mesmo encerrar o prazo desta mostra?',
        text: "Esta ação irá encerrar todas as ações relacionadas a esta mostra!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonColor: '#2fb344',
        confirmButtonText: 'Sim, encerrar prazo!'
    }).then((result) => {
        if (result.value) {
            $.ajax({
                type: "POST",
                data: {codigo: codigo, processo: processo, acao: 'mostra-encerrar'}, 
                url: "mostra-encerrar",
                success: function (result) {
                    result = result.split('|');
                    if (parseInt(result[0]) === 1) {
                        //$('#mostra' + codigo).addClass('bg-red-lt');
                        Swal.fire({
                            title: result[1],
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(function(res) {
                            location.reload();
                        });
                    } else {
                        Swal.fire({
                            text: result[1],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    }
                }
            });
        }
    });
});

$(document).on('click', '#btnFinalizaMostra', function(e) {
    e.preventDefault();
    var btn = $(this);
    var codigo = $(this).attr('data-codigo');
    var titulo = 'Deseja mesmo finalizar esta Mostra?';
    var textoAprove = "Ao finalizar, o Gerente e toda a Equipe de Comunicação serão notificados de que as imagens estão renomeadas e disponíveis para uso.";
    var btnConfirmText = "Sim, quero finalizar!";

    Swal.fire({
        title: titulo,
        text: textoAprove,
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonText: btnConfirmText,
        confirmButtonColor: '#2fb344',
    }).then((result) => {
        if (result.value) {
            btn.attr('disabled',true);
            Swal.fire({
                title: 'Enviando, aguarde...',
                showConfirmButton: false,
                allowOutsideClick: false,
                didOpen: function() {
                    Swal.showLoading()
                }
            });
            $.ajax({
                type: "POST",
                data: {codigo: codigo, finalizar: 'S'},
                url: "finalizar-mostra",
                success: function (result) {
                    result = result.split('|');
                    if (parseInt(result[1]) === 1) {
                        Swal.fire({
                            title: result[2],
                            html: result[3],
                            icon: 'success',
                            timer: 4000,
                            showConfirmButton: false,
                            allowOutsideClick: false,
                        }).then(function(res) {
                            location.href = 'mostras';
                        });
                    } else {
                        btn.attr('disabled',false);
                        Swal.fire({
                            text: result[2],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    }
                }
            });
        }
    });
});

$(document).on('click', '.btnAproveProject', function(e) {
    e.preventDefault();
    var btn = $(this);
    var codigo = $(this).attr('data-codigo');
    var processo = $(this).attr('data-process');
    var marketingCoop = $(this).attr('data-marketing_coop');
    var connectARCH = $(this).attr('data-connectarch');
    var verba = $('#verbaAcao').val();
    var obs_marketing_coo = $('#obs_marketing_cooperado').val();
    var titulo = 'Deseja mesmo aprovar o Projeto?';
    var textoAprove = "";
    var btnConfirmText = "Sim, quero aprovar!";

    if(parseInt(processo) === 2){
        textoAprove = 'Se você aprovar, o projeto será encaminhado para a aprovação da Comunicação.';
        if(verba === undefined || verba === null || verba === ''){
            Swal.fire({
                title: 'Informe a verba que cobrirá o custo da ação!',
                icon: 'warning',
                timer: 3000,
                showConfirmButton: false,
                allowOutsideClick: false
            });
            $('#verbaAcao').addClass('error');
            return false;
        }
    }else if (parseInt(processo) === 3){
        textoAprove = 'Se você aprovar, o projeto será encaminhado para a aprovação do Coordenador de branding.';
    }else if (parseInt(processo) === 11){
        textoAprove = 'Se você aprovar, o projeto será encaminhado ao Analista de Merchan para levantamento de valores e estoque.';
    }else if(parseInt(processo) === 5){
        titulo = 'Deseja mesmo aprovar o valor total do projeto?';
        textoAprove = 'Se você aprovar, o projeto será encaminhado para faturamento dos produtos.';
        if(marketingCoop === 'S'){
            if(obs_marketing_coo === undefined || obs_marketing_coo === null || obs_marketing_coo === ''){
                Swal.fire({
                    title: 'Envie as observações para Marketing Cooperado!',
                    icon: 'warning',
                    timer: 3000,
                    showConfirmButton: false,
                    allowOutsideClick: false
                });
                $('#obs_marketing_cooperado').addClass('error');
                return false;
            }
        }else if(connectARCH === 'S'){
            textoAprove = 'Se você aprovar, o projeto será encaminhado para aprovação do Gerente Connectarch.';
        }

    }else if(parseInt(processo) === 6){
        textoAprove = 'Se você aprovar, o projeto será encaminhado para faturamento dos produtos.';
    }else{
        titulo = 'Ocorrreu um erro!';
        textoAprove = "Os dados não indicam um processo de aprovação, reporte este erro ao ADM";
        btnConfirmText = "Ok, vou reportar";
    }

    Swal.fire({
        title: titulo,
        text: textoAprove,
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonText: btnConfirmText,
        confirmButtonColor: '#2fb344',
    }).then((result) => {
        if (result.value) {
            btn.attr('disabled',true);
            Swal.fire({
                title: 'Enviando, aguarde...',
                showConfirmButton: false,
                allowOutsideClick: false,
                didOpen: function() {
                    Swal.showLoading()
                }
            });
            $.ajax({
                type: "POST",
                data: {codigo: codigo, verba: verba, obs_marketing_coo: obs_marketing_coo, processo: processo, aprovado:'S'},
                url: "envia-aprovacao",
                success: function (result) {
                    result = result.split('|');
                    if (parseInt(result[0]) === 1) {
                        $('#aproveContent').remove();
                        Swal.fire({
                            title: result[1],
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false,
                        }).then(function(res) {
                            location.href = 'mostras';
                        });
                    } else {
                        btn.attr('disabled',false);
                        Swal.fire({
                            text: result[1],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    }
                }
            });
        }
    });
});

$(document).on('click', '.btnAjustesProject', function(e) {
    e.preventDefault();
    var btn = $(this);
    var codigo = $(this).attr('data-codigo');
    var processo = $(this).attr('data-process');
    var text = '';
    if(parseInt(processo) === 3 || parseInt(processo) === 5 || parseInt(processo) === 11 ){
        Swal.fire({
            input: 'textarea',
            inputLabel: 'Informe os ajustes necessários.',
            inputPlaceholder: 'Digite aqui os ajustes...',
            inputAttributes: {
                'aria-label': 'Informe os ajustes necessários'
            },
            inputValidator: (value) => {
                if (!value) {
                    return 'Este campo é obrigatório'
                }else{
                    text =  value;
                }
            },
            confirmButtonText: 'Enviar',
            confirmButtonColor: '#2fb344',
            showCancelButton: true
        }).then(function(res) {

            if (res.isConfirmed) {
                btn.attr('disabled', true);
                Swal.fire({
                    title: 'Enviando, aguarde...',
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    didOpen: function() {
                        Swal.showLoading()
                    }
                });
                $.ajax({
                    type: "POST",
                    data: {codigo: codigo, processo: processo, motivo: text, interessa: 'S', aprovado: 'N'},
                    url: "envia-aprovacao",
                    success: function (result) {
                        result = result.split('|');
                        if (parseInt(result[0]) === 1) {
                            $('#aproveContent').remove();
                            Swal.fire({
                                title: result[1],
                                icon: 'success',
                                timer: 3000,
                                showConfirmButton: false,
                                allowOutsideClick: false,
                            }).then(function (res) {
                                location.href = 'mostras';
                            });
                        } else {
                            btn.attr('disabled', false);
                            Swal.fire({
                                text: result[1],
                                icon: 'error',
                                timer: 3000,
                                showConfirmButton: false,
                                allowOutsideClick: false
                            });
                        }
                    }
                });
            }
        });
    }else{

        Swal.fire({
            title: 'Ocorrreu um erro!',
            text: "Os dados não indicam um processo de aprovação, reporte este erro ao ADM",
            icon: "error",
            timer: 3000,
            showConfirmButton: false,
            allowOutsideClick: false
        });
    }
});

$(document).on('click', '.btnReproveProject', function(e) {
    e.preventDefault();
    var btn = $(this);
    var codigo = $(this).attr('data-codigo');
    var processo = $(this).attr('data-process');
    var text = '';
    var aviso = '';
    if(parseInt(processo) === 2 || parseInt(processo) === 3 || parseInt(processo) === 5 || parseInt(processo) === 6 || parseInt(processo) === 11 ){

        if(parseInt(processo) === 6){
            aviso = "Se você reprovar, o projeto retornará para o gerente da filial.";
        }else{
            aviso = "Se você reprovar, o projeto será encerrado.";
        }

        Swal.fire({
            title: 'Deseja realmente reprovar o projeto?',
            text: aviso,
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            cancelButtonColor: '#d63939',
            confirmButtonText: 'Sim, quero reprovar!',
            confirmButtonColor: '#2fb344',
            }).then((result) => {
                if (result.value) {
                    Swal.fire({
                        input: 'textarea',
                        inputLabel: 'Informe o motivo da reprovação.',
                        inputPlaceholder: 'Digite aqui o motivo...',
                        inputAttributes: {
                            'aria-label': 'Informe o motivo da reprovação'
                        },
                        inputValidator: (value) => {
                            if (!value) {
                                return 'Este campo é obrigatório'
                            }else{
                                text =  value;
                            }
                        },
                        confirmButtonText: 'Enviar',
                        confirmButtonColor: '#2fb344',
                        showCancelButton: true
                    }).then(function(res) {
                        if (res.isConfirmed) {
                            btn.attr('disabled', true);
                            Swal.fire({
                                title: 'Enviando, aguarde...',
                                showConfirmButton: false,
                                allowOutsideClick: false,
                                didOpen: function() {
                                    Swal.showLoading()
                                }
                            });
                            $.ajax({
                                type: "POST",
                                data: {codigo: codigo, processo: processo, motivo: text, interessa: 'N', aprovado: 'N'},
                                url: "envia-aprovacao",
                                success: function (result) {
                                    result = result.split('|');
                                    if (parseInt(result[0]) === 1) {
                                        $('#aproveContent').remove();
                                        Swal.fire({
                                            title: result[1],
                                            icon: 'success',
                                            timer: 3000,
                                            showConfirmButton: false,
                                            allowOutsideClick: false,
                                        }).then(function (res) {
                                            location.href = 'mostras';
                                        });
                                    } else {
                                        btn.attr('disabled', false);
                                        Swal.fire({
                                            text: result[1],
                                            icon: 'error',
                                            timer: 3000,
                                            showConfirmButton: false,
                                            allowOutsideClick: false
                                        });
                                    }
                                }
                            });
                        }
                    });
            }
        });
    }else{

        Swal.fire({
            title: 'Ocorrreu um erro!',
            text: "Os dados não indicam um processo de aprovação, reporte este erro ao ADM",
            icon: "error",
            timer: 3000,
            showConfirmButton: false,
            allowOutsideClick: false
        });
    }
});

/**
 * ADICIONAR ENTREVISTA
 */
function formEntrevistaCadastrar() {
    $("#formEntrevistaCadastrar").validate({
        submitHandler: function (form) {
            //SUBMIT form
            $(form).ajaxSubmit({
                beforeSubmit: function () {
                    $('#formEntrevistaCadastrar .btnSave').html('<span class="spinner-border spinner-border-sm ms-2" role="status"></span> Salvando ...').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    console.log(result);
                    if (parseInt(result[0]) === 1) {
                        Swal.fire({
                            title: result[1],
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(function (res) {
                            $('#cadastro-entrevista').modal('hide');
                        });
                    } else {
                        Swal.fire({
                            text: result[1],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(function (res) {
                            $('#formEntrevistaCadastrar .btnSave').html('Salvar').attr('disabled', false);
                        });
                    }
                }
            });
        }
    });
}
function formInserirValor() {
    $('body').on('keyup', '.priceUnit', function(){

        var total = 0;
        var value = 0;
        $('.priceUnit').each(function(){
            if($(this).val() !== ''){
                value = parseFloat($(this).val().replace('.','').replace(',','.'));
                console.log('v = '+ value);
                total = total + value;
            }
        });

        if(total > 0){

            $('#valorTotalField').val(total.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }));
        }else{
            $('#valorTotalField').val('');
        }
    })
    $("#formInserirValor").validate({
        submitHandler: function (form) {
            //SUBMIT form
            $(form).ajaxSubmit({
                beforeSubmit: function () {
                    $('#formInserirValor .btnSave').html('<span class="spinner-border spinner-border-sm ms-2" role="status"></span> Salvando ...').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    console.log(result);
                    if (parseInt(result[1]) === 1) {
                        Swal.fire({
                            title: result[2],
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(function (res) {
                            $('#inserir-valor').modal('hide');
                            location.reload();
                        });
                    } else {
                        Swal.fire({
                            text: result[2],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(function (res) {
                            $('#formInserirValor .btnSave').html('Salvar').attr('disabled', false);
                        });
                    }
                }
            });
        }
    });
}

function formLiberaProduto() {
    $("#formLiberaProduto").validate({
        submitHandler: function (form) {
            //SUBMIT form
            $(form).ajaxSubmit({
                beforeSubmit: function () {
                    $('#formLiberaProduto .btnSave').html('<span class="spinner-border spinner-border-sm ms-2" role="status"></span> Salvando ...').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    console.log(result);
                    if (parseInt(result[1]) === 1) {
                        Swal.fire({
                            title: result[2],
                            html: result[3],
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(function (res) {
                            $('#liberar-produto').modal('hide');
                            location.reload();
                        });
                    } else {
                        Swal.fire({
                            text: result[2],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(function (res) {
                            $('#formLiberaProduto .btnSave').html('Salvar').attr('disabled', false);
                        });
                    }
                }
            });
        }
    });
}


$(document).on('change', '.checkTemEstoque', function() {
    var val = $(this).val();
    if(val !== '' && val !== null && val!== undefined){
        $('#formInserirValor .btnSave').removeClass('d-none');
        if(val === 'S'){
            $('#obsEstoqueContent').addClass('d-none');
            $('#valorTotalContent').removeClass('d-none');
            $('#obsEstoqueContent textarea').removeAttr('required').val('').html('');
            $('#valorTotalContent input').attr('required','required');
            $('.priceUnit').attr('required','required');
        }else{
            $('#obsEstoqueContent').removeClass('d-none');
            $('#valorTotalContent').addClass('d-none');
            $('#obsEstoqueContent textarea').attr('required','required');
            $('#valorTotalContent input').removeAttr('required').val('');
            $('.priceUnit').removeAttr('required').val('');
        }
    }
});

/**
 * GALERIA
 */
if ($("#input-files").length) {
    $("#input-files").fileinput({
        language: 'pt-BR',
        uploadUrl: "galeria/upload", // server upload action
        uploadAsync: false,
        maxFileCount: 20,
        initialCaption: false,
        minImageWidth: 1000,
        allowedPreviewTypes: null, // disable preview of standard types
        allowedPreviewMimeTypes: ['image/jpeg', 'image/png'],
        allowedFileExtensions: ['jpg', 'jpeg', 'png'],
        uploadExtraData: function () {
            return {
                mostraId: $("#mostraId").val(),
                mostraTitulo: $("#mostraTitulo").val(),
            };
        }
    }).on('filebatchuploadcomplete', function (event, files, extra) {
        location.reload();
    });

    $('#sortlist .row-cards').sortable({
        items: '> .card-imagem',
        forceHelperSize: true,
        cursor: "move",
        opacity: 0.5,
        handle: ".ribbon",
        update: function(){
            var order = $("#sortlist .row-cards").sortable("serialize");
            $.post("galeria/ordem", order ,function(theResponse){
                // location.reload();
            });
        }
    }).disableSelection();
}

$("#formLinkFotos").validate({
    submitHandler: function (form) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                $('#formLinkFotos .btnSave').html('<span class="spinner-border spinner-border-sm mr-2" role="status"> </span> Salvando ...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                console.log(result);
                if(parseInt(result[0]) === 1){
                    Swal.fire({
                        title: result[1],
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        location.reload();
                    });
                }else{
                    Swal.fire({
                        text: result[1],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        $('#formLinkFotos .btnSave').html('Salvar').attr('disabled', false);
                    });
                }
            }
        });
    }
});

$("#formTermoFotos").validate({
    submitHandler: function (form) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                $('#formTermoFotos .btnSave').html('<span class="spinner-border spinner-border-sm mr-2" role="status"> </span> Salvando ...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                console.log(result);
                if(parseInt(result[0]) === 1){
                    Swal.fire({
                        title: result[1],
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        location.reload();
                    });
                }else{
                    Swal.fire({
                        text: result[1],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        $('#formTermoFotos .btnSave').html('Salvar').attr('disabled', false);
                    });
                }
            }
        });
    }
});

$("#formFotografo").validate({
    submitHandler: function (form) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                $('#formFotografo .btnSave').html('<span class="spinner-border spinner-border-sm mr-2" role="status"> </span> Salvando ...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                console.log(result);
                if(parseInt(result[0]) === 1){
                    Swal.fire({
                        title: result[1],
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        location.reload();
                    });
                }else{
                    Swal.fire({
                        text: result[1],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        $('#formFotografo .btnSave').html('Salvar').attr('disabled', false);
                    });
                }
            }
        });
    }
});

$(document).on('click', '.btn-imagem-remover', function(e) {
    e.preventDefault();
    var idimagem = $(this).attr('data-codigo');
    var processo = $(this).attr('data-processo');
    var mostra_id = $(this).attr('data-mostra');
    Swal.fire({
        title: 'Deseja remover realmente?',
        text: "Esta ação irá remover este item permanentemente!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonColor: '#2fb344',
        confirmButtonText: 'Sim, excluir!'
    }).then((result) => {
        if (result.value) {
            $.ajax({
                type: "POST",
                data: { idimagem: idimagem, processo: processo, mostra_id: mostra_id },
                url: "galeria/remover",
                success: function (result) {
                    result = result.split('|');
                    console.log(idimagem, 1, result);
                    if (parseInt(result[0]) === 1) {
                        console.log(idimagem);
                        $('#ID_' + idimagem).remove();
                        Swal.fire({
                            title: result[1],
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    } else {
                        Swal.fire({
                            text: result[1],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    }
                }
            });
        }
    });
});

function formAlterarImagem() {
    $("#formAlterarImagem").validate({
        submitHandler: function (form) {
            //SUBMIT form
            $(form).ajaxSubmit({
                beforeSubmit: function () {
                    $('#formAlterarImagem .btnSave').html('<span class="spinner-border spinner-border-sm ms-2" role="status"></span> Salvando ...').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    console.log(result);
                    if (parseInt(result[0]) === 1) {
                        Swal.fire({
                            title: result[1],
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(function (res) {
                            $('#alterar-imagem').modal('hide');
                            location.reload();
                        });
                    } else {
                        Swal.fire({
                            text: result[1],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(function (res) {
                            $('#formAlterarImagem .btnSave').html('Salvar').attr('disabled', false);
                        });
                    }
                }
            });
        }
    });
}

$(document).on('click', '.btn-galeria-remover', function(e) {
    e.preventDefault();
    var mostra = $(this).attr('data-codigo');
    var tipo = $(this).attr('data-tipo');
    var status = $(this).attr('data-status');
    var processo = $(this).attr('data-processo');
    var tipoName = $(this).attr('data-name');
    Swal.fire({
        title: 'Deseja remover realmente?',
        text: "Esta ação irá remover "+ tipoName +" !",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonColor: '#2fb344',
        confirmButtonText: 'Sim, excluir!'
    }).then((result) => {
        if (result.value) {
            $.ajax({
                type: "POST",
                data: { mostra_id: mostra, tipo: tipo, status: status , processo: processo },
                url: "galeria/remover-all",
                success: function (result) {
                    result = result.split('|');
                    if (parseInt(result[0]) === 1) {
                        Swal.fire({
                            title: result[1],
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(function (res) {
                            location.reload();
                        });
                    } else {
                        Swal.fire({
                            text: result[1],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    }
                }
            });
        }
    });
});

$(document).on('click', '#btnSolicitarFotos', function(e) {
    var mostraId = $(this).attr('data-codigo');
    Swal.fire({
        title: 'Deseja mesmo solicitar mais fotos?',
        text: 'Ao solicitar mais fotos o status será setado para "fotos não enviadas"',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonColor: '#2fb344',
        confirmButtonText: 'Sim, quero solicitar!'
    }).then((result) => {
        if (result.value) {
            Swal.fire({
                input: 'textarea',
                inputLabel: 'Informe o motivo da solicitação.',
                inputPlaceholder: 'Digite aqui o motivo...',
                inputAttributes: {
                    'aria-label': 'Informe o motivo da solicitação'
                },
                inputValidator: (value) => {
                    if (!value) {
                        return 'Este campo é obrigatório'
                    }else{
                        text =  value;
                    }
                },
                confirmButtonText: 'Enviar',
                confirmButtonColor: '#2fb344',
                showCancelButton: true
            }).then(function(res) {

                Swal.fire({
                    title: 'Enviando, aguarde...',
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    didOpen: function() {
                        Swal.showLoading()
                    }
                });

                $.ajax({
                    type: "POST",
                    data: { mostra_id: mostraId, motivo: text},
                    url: "aprovar/solicitar-fotos",
                    success: function (result) {
                        result = result.split('|');
                        if (parseInt(result[0]) === 1) {
                            Swal.fire({
                                title: result[1],
                                icon: 'success',
                                timer: 3000,
                                showConfirmButton: false,
                                allowOutsideClick: false
                            }).then(function (res) {
                                location.reload();
                            });
                        } else {
                            Swal.fire({
                                text: result[1],
                                icon: 'error',
                                timer: 3000,
                                showConfirmButton: false,
                                allowOutsideClick: false
                            });
                        }
                    }
                });
            });         
            
        }
    });
})

$(document).on('click', '#btnAprovarFotos', function(e) {
    var mostraId = $(this).attr('data-codigo');
    Swal.fire({
        title: 'Deseja mesmo considerar as fotos aprovadas?',
        text: 'Esta ação irá liberar o projeto para ser finalizado.',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonColor: '#2fb344',
        confirmButtonText: 'Sim, quero aprovar!'
    }).then((result) => {
        if (result.value) {
            Swal.fire({
                title: 'Enviando, aguarde...',
                showConfirmButton: false,
                allowOutsideClick: false,
                didOpen: function() {
                    Swal.showLoading()
                }
            });
            $.ajax({
                type: "POST",
                data: { mostra_id: mostraId},
                url: "aprovar/setar-aprovado",
                success: function (result) {
                    result = result.split('|');
                    if (parseInt(result[0]) === 1) {
                        Swal.fire({
                            title: result[1],
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(function (res) {
                            location.reload();
                        });
                    } else {
                        Swal.fire({
                            text: result[1],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    }
                }
            });
        }
    });
})

/*
//Inicio BACKUP formAprovaFotos 13/12/2023
$("#formAprovaFotos").validate({
    submitHandler: function (form) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                $('#formAprovaFotos .btnSave').html('<span class="spinner-border spinner-border-sm ms-2" role="status"></span> Salvando ...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                console.log(result);
                if (parseInt(result[0]) === 1) {
                    Swal.fire({
                        title: result[1],
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function (res) {
                        location.reload();
                    });
                } else if(parseInt(result[0]) === 2){
                    var mostraId = result[2];
                    Swal.fire({
                        title: result[1],
                        text: 'Ao solicitar mais fotos o status será setado para "fotos não enviadas", ou você já pode considerar as fotos aprovadas.',
                        icon: 'warning',
                        allowOutsideClick: false,
                        showCancelButton: true,
                        cancelButtonText: 'Considerar fotos aprovadas',
                        cancelButtonColor: '#2fb344',
                        confirmButtonColor: '#646464',
                        confirmButtonText: 'Quero solicitar mais fotos'
                    }).then((result) => {
                        if (result.value) {
                            Swal.fire({
                                title: 'Enviando, aguarde...',
                                showConfirmButton: false,
                                allowOutsideClick: false,
                                didOpen: function() {
                                    Swal.showLoading()
                                }
                            });
                            $.ajax({
                                type: "POST",
                                data: { mostra_id: mostraId},
                                url: "aprovar/solicitar-fotos",
                                success: function (result) {
                                    result = result.split('|');
                                    if (parseInt(result[0]) === 1) {
                                        Swal.fire({
                                            title: result[1],
                                            icon: 'success',
                                            timer: 3000,
                                            showConfirmButton: false,
                                            allowOutsideClick: false
                                        }).then(function (res) {
                                            location.reload();
                                        });
                                    } else {
                                        Swal.fire({
                                            text: result[1],
                                            icon: 'error',
                                            timer: 3000,
                                            showConfirmButton: false,
                                            allowOutsideClick: false
                                        });
                                    }
                                }
                            });
                        }else{
                            Swal.fire({
                                title: 'Enviando, aguarde...',
                                showConfirmButton: false,
                                allowOutsideClick: false,
                                didOpen: function() {
                                    Swal.showLoading()
                                }
                            });
                            $.ajax({
                                type: "POST",
                                data: { mostra_id: mostraId},
                                url: "aprovar/setar-aprovado",
                                success: function (result) {
                                    result = result.split('|');
                                    if (parseInt(result[0]) === 1) {
                                        Swal.fire({
                                            title: result[1],
                                            icon: 'success',
                                            timer: 3000,
                                            showConfirmButton: false,
                                            allowOutsideClick: false
                                        }).then(function (res) {
                                            location.reload();
                                        });
                                    } else {
                                        Swal.fire({
                                            text: result[1],
                                            icon: 'error',
                                            timer: 3000,
                                            showConfirmButton: false,
                                            allowOutsideClick: false
                                        });
                                    }
                                }
                            });
                        }
                    });

                } else if(parseInt(result[0]) === 3){
                    Swal.fire({
                        title: result[1],
                        icon: 'warning',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function (res) {
                        location.reload();
                    });

                } else {
                    Swal.fire({
                        text: result[1],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function (res) {
                        $('#formAlterarImagem .btnSave').html('Salvar Aprovação').attr('disabled', false);
                    });
                }
            }
        });
    }
});
//Fim BACKUP formAprovaFotos 13/12/2023 
*/

$("#formAprovaFotos").validate({
    submitHandler: function (form) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                $('#formAprovaFotos .btnSave').html('<span class="spinner-border spinner-border-sm ms-2" role="status"></span> Salvando ...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                console.log(result);
                if (parseInt(result[0]) === 1) {
                    Swal.fire({
                        title: result[1],
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function (res) {
                        location.reload();
                    });
                } else if(parseInt(result[0]) === 2){
                    var mostraId = result[2];
                    var text;
                    Swal.fire({
                        title: result[1],
                        text: 'Ao solicitar mais fotos o status será setado para "fotos não enviadas", ou você já pode considerar as fotos aprovadas.',
                        icon: 'warning',
                        allowOutsideClick: false,
                        showCancelButton: true,
                        cancelButtonText: 'Considerar fotos aprovadas',
                        cancelButtonColor: '#2fb344',
                        confirmButtonColor: '#646464',
                        confirmButtonText: 'Quero solicitar mais fotos'
                    }).then((result) => {
                        if (result.value) {

                            Swal.fire({
                                input: 'textarea',
                                inputLabel: 'Informe o motivo da solicitação.',
                                inputPlaceholder: 'Digite aqui o motivo...',
                                inputAttributes: {
                                    'aria-label': 'Informe o motivo da solicitação'
                                },
                                inputValidator: (value) => {
                                    if (!value) {
                                        return 'Este campo é obrigatório'
                                    }else{
                                        text =  value;
                                    }
                                },
                                confirmButtonText: 'Enviar',
                                confirmButtonColor: '#2fb344',
                                showCancelButton: true
                            }).then(function(res) {
                                Swal.fire({
                                    title: 'Enviando, aguarde...',
                                    showConfirmButton: false,
                                    allowOutsideClick: false,
                                    didOpen: function() {
                                        Swal.showLoading()
                                    }
                                });
                                $.ajax({
                                    type: "POST",
                                    data: { mostra_id: mostraId, motivo: text },
                                    url: "aprovar/solicitar-fotos",
                                    success: function (result) {
                                        result = result.split('|');
                                        if (parseInt(result[0]) === 1) {
                                            Swal.fire({
                                                title: result[1],
                                                icon: 'success',
                                                timer: 3000,
                                                showConfirmButton: false,
                                                allowOutsideClick: false
                                            }).then(function (res) {
                                                location.reload();
                                            });
                                        } else {
                                            Swal.fire({
                                                text: result[1],
                                                icon: 'error',
                                                timer: 3000,
                                                showConfirmButton: false,
                                                allowOutsideClick: false
                                            });
                                        }
                                    }
                                });
                                
                            });                            
                            
                        }else{
                            Swal.fire({
                                title: 'Enviando, aguarde...',
                                showConfirmButton: false,
                                allowOutsideClick: false,
                                didOpen: function() {
                                    Swal.showLoading()
                                }
                            });
                            $.ajax({
                                type: "POST",
                                data: { mostra_id: mostraId},
                                url: "aprovar/setar-aprovado",
                                success: function (result) {
                                    result = result.split('|');
                                    if (parseInt(result[0]) === 1) {
                                        Swal.fire({
                                            title: result[1],
                                            icon: 'success',
                                            timer: 3000,
                                            showConfirmButton: false,
                                            allowOutsideClick: false
                                        }).then(function (res) {
                                            location.reload();
                                        });
                                    } else {
                                        Swal.fire({
                                            text: result[1],
                                            icon: 'error',
                                            timer: 3000,
                                            showConfirmButton: false,
                                            allowOutsideClick: false
                                        });
                                    }
                                }
                            });
                        }
                    });

                } else if(parseInt(result[0]) === 3){
                    Swal.fire({
                        title: result[1],
                        icon: 'warning',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function (res) {
                        location.reload();
                    });

                } else {
                    Swal.fire({
                        text: result[1],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function (res) {
                        $('#formAlterarImagem .btnSave').html('Salvar Aprovação').attr('disabled', false);
                    });
                }
            }
        });
    }
});

/**
 * Abre campo observacao reprovados
 */
$(document).on('change', '.inputAprove', function() {
    var val = $(this).val();
    var target = $(this).attr('data-target');
    if(val !== '' && val !== null && val!== undefined){
        if(val === 'S'){
            $('.'+target).show();
            $('.'+target).children('textarea').attr('placeholder','Orientações para renomear as fotos').removeAttr('required').val('');
            console.log('Orientações para renomear as fotos');
        }else{
            $('.'+target).show();
            $('.'+target).children('textarea').attr('placeholder','Motivo da reprovação').attr('required','required').val('');
            console.log('Motivo da reprovação');
        }
    }
});


const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});

function toastFire(response, Toast) {
    response = response.split('|');
    Toast.fire({
        icon: (parseInt(response[1]) === 1) ? 'success' : 'error',
        title: response[2]
    });
    return true;
}

if ($('.upd-text').length) {
    $('.upd-text').editable({
        tpl: '<input type="text" class="form-control">',
        emptytext: 'Editar',
        success: function (response, newValue) {
            toastFire(response, Toast);
        }
    });
}

if ($('.upd-textarea').length) {
    $('.upd-textarea').editable({
        tpl: '<textarea class="form-control"></textarea>',
        emptytext: 'Editar',
        success: function (response, newValue) {
            toastFire(response, Toast);
        }
    });
}
$("#formLogin").validate({
    errorClass: "is-invalid",
    validClass: "is-valid",
    submitHandler: function (form, event) {
        event.preventDefault();
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                $('#formLogin #btnLogin').addClass('loader').html('Enviando...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                if(parseInt(result[1]) == 1){
                    $('#formLogin #btnLogin').removeClass('loader').addClass('success').html(result[2]);
                    setTimeout(function(){
                        location.href = './'+result[3];
                    },2000);
                }else{
                    $('#formLogin #btnLogin').removeClass('loader').addClass('error').html(result[2]);
                    setTimeout(function () {
                        $('#formLogin #btnLogin').removeClass('error').html('Login').attr('disabled', false);
                    }, 3000);
                }
            }
        });
    }
});

$("#formLoginValida").validate({
    errorClass: "is-invalid",
    validClass: "is-valid"
});
$("#formUsuario").validate({
    submitHandler: function (form) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                $('#formUsuario .btnSave').html('<span class="spinner-border spinner-border-sm mr-2" role="status"></span> Salvando ...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                console.log(result);
                if(parseInt(result[0]) == 1){
                    Swal.fire({
                        title: result[1],
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        location.reload();
                    });
                }else{
                    Swal.fire({
                        html: result[1],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        $('#formUsuario .btnSave').html('Alterar usuário').attr('disabled', false);
                    });
                }
            }
        });
    }
});

$("#formNovoUsuario").validate({
    //SUBMIT form
    submitHandler: function (form) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                $('#formNovoUsuario .btnSave').html('<span class="spinner-border spinner-border-sm mr-2" role="status"></span> Salvando ...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                console.log(result);
                if(parseInt(result[0]) == 1){
                    Swal.fire({
                        title: result[1],
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        location.href = 'usuario/editar/'+result[2];
                    });
                }else{
                    Swal.fire({
                        html: result[1],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        $('#formNovoUsuario .btnSave').html('Salvar').attr('disabled', false);
                    });
                }
            }
        });
    }
});

$(document).on('click', '.btnExcluirUsuario', function(e) {
    e.preventDefault();
    var codigo = $(this).attr('data-codigo');
    Swal.fire({
        title: 'Deseja remover realmente?',
        text: "Esta ação irá remover todas as informações relacionadas deste usuário!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonText: 'Sim, excluir!'
    }).then((result) => {
        if (result.value) {
            $.ajax({
                type: "POST",
                data: {codigo: codigo, acao: 'usuario-remover'},
                url: "usuario-remover",
                success: function (result) {
                    result = result.split('|');
                    if (parseInt(result[0]) == 1) {
                        $('#user' + codigo).remove();
                        Swal.fire({
                            title: result[1],
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    } else {
                        Swal.fire({
                            text: result[1],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    }
                }
            });
        }
    });
});